import { FC } from 'react'
import { UserDetails } from 'components/User'
import { UserProtectedRoute } from 'routes'

const UserDetailsPage: FC = () => {
  return (
    <UserProtectedRoute>
      <UserDetails />
    </UserProtectedRoute>
  )
}

export default UserDetailsPage
